var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable, reactive } from '@serviceos-rn/core';
import { ISendTipUseCaseType } from '../../../Domain/UseCases/Tip/SendTipUseCase/ISendTipUseCase';
import { ISetTipOptionUseCaseType } from '../../../Domain/UseCases/Tip/SetTipOptionUseCase/ISetTipOptionUseCase';
import { IContinueUseCaseType } from '../../../Domain/UseCases/Tip/ContinueUseCase/IContinueUseCase';
import { IGetTipStateUseCaseType } from '../../../Domain/UseCases/Tip/GetTipStateUseCase/IGetTipStateUseCase';
import { ITryAgainUseCaseType } from '../../../Domain/UseCases/Tip/TryAgainUseCase/ITryAgainUseCase';
let TipScreenViewModel = class TipScreenViewModel {
    constructor(getTip, sendTip, setTipOptions, continueUseCase, tryAgainUseCase) {
        this.getTip = getTip;
        this.sendTip = sendTip;
        this.setTipOptions = setTipOptions;
        this.continueUseCase = continueUseCase;
        this.tryAgainUseCase = tryAgainUseCase;
        this.viewData = {
            error: '',
            loading: false,
            interactions: [],
            units: []
        };
        this.submit = this.submit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onErrorDismiss = this.onErrorDismiss.bind(this);
        this.getTip.execute().observe(this, value => {
            var _a;
            this.updateViewData({
                error: '',
                units: ((_a = value.tip.payload) === null || _a === void 0 ? void 0 : _a.units) || [],
                tipOptions: value.tip,
                interactions: this.createInteractions(value.interactions)
            });
        });
    }
    onErrorDismiss() {
        this.updateViewData({ error: '' });
    }
    createInteractions(interactions) {
        const map = {
            send: (interaction) => {
                return Object.assign(Object.assign({}, interaction), { wrapperStyle: {
                        width: '100%'
                    }, onPress: () => this.submit() });
            },
            tryAgain: (interaction) => {
                return Object.assign(Object.assign({}, interaction), { wrapperStyle: {
                        width: '100%'
                    }, onPress: () => this.tryAgain() });
            },
            continue: (interaction) => {
                return Object.assign(Object.assign({}, interaction), { wrapperStyle: {
                        width: '100%'
                    }, onPress: () => this.continue() });
            }
        };
        return interactions.map(interaction => map[interaction.action](interaction));
    }
    tryAgain() {
        this.updateViewData({ loading: true });
        return this.tryAgainUseCase.execute()
            .then(() => {
            this.updateViewData({ loading: false });
        })
            .catch((error) => {
            this.updateViewData({ loading: false, error: error.message });
        });
    }
    onChange(options) {
        this.setTipOptions.execute(options);
    }
    submit() {
        this.updateViewData({ loading: true, error: '' });
        return this.sendTip.execute()
            .catch(error => {
            this.updateViewData({
                loading: false,
                error: error.message
            });
        })
            .finally(() => {
            this.updateViewData({ loading: false });
        });
    }
    continue() {
        return this.continueUseCase.execute();
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
    onDestroy() {
        this.errorTimeout && clearTimeout(this.errorTimeout);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], TipScreenViewModel.prototype, "viewData", void 0);
TipScreenViewModel = __decorate([
    injectable(),
    __param(0, inject(IGetTipStateUseCaseType)),
    __param(1, inject(ISendTipUseCaseType)),
    __param(2, inject(ISetTipOptionUseCaseType)),
    __param(3, inject(IContinueUseCaseType)),
    __param(4, inject(ITryAgainUseCaseType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object])
], TipScreenViewModel);
export { TipScreenViewModel };
